import { Modal } from "@ews-admin/global-design-system";
import React from "react";
import { useTranslation } from "react-i18next";

interface ConfirmationModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  variant?: "danger" | "warning" | "info";
  isLoading?: boolean;
}

// Map the confirmation-specific variants onto the design-system Modal variants.
const MODAL_VARIANT: Record<
  NonNullable<ConfirmationModalProps["variant"]>,
  "error" | "warning" | "info"
> = {
  danger: "error",
  warning: "warning",
  info: "info",
};

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  title,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  variant = "danger",
  isLoading = false,
}) => {
  // MED-1687: the defaults showed "Cancel" / "Confirm" on a French screen
  const { t } = useTranslation();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      title={title}
      variant={MODAL_VARIANT[variant]}
      size="md"
      primaryAction={confirmLabel ?? t("common.confirm")}
      secondaryAction={cancelLabel ?? t("common.cancel")}
      onPrimaryAction={onConfirm}
      onSecondaryAction={onCancel}
      isLoading={isLoading}
      closeOnOverlayClick={!isLoading}
    >
      <p className="text-sm leading-relaxed text-neutral-600">{message}</p>
    </Modal>
  );
};
